//Swiper JS (https://swiperjs.com/)
import Swiper from 'swiper';
import 'swiper/css';

window.addEventListener('load', function () {
    if (document.querySelector('.swiper') != null) {
        const swiper = new Swiper('.swiper', {
            centeredSlides: true,
            slidesPerView: 1.2,
            spaceBetween: 10,
            grid: {
                rows: 2,
            },
            breakpoints: {
                576: {
                    centeredSlides: false,
                    slidesPerView: 2,
                    spaceBetween: 15
                },
                768: {
                    centeredSlides: false,
                    spaceBetween: 30
                },
                992: {
                    centeredSlides: false,
                    slidesPerView: 3,
                    spaceBetween: 30
                }
            }
        });
    }
});